<template>
  <div v-if="evaData" v-hotkey="keymap">
    <div class="eva-header container-fluid">
      <div class="d-flex align-items-center">
        <div class="d-inline-flex align-items-center">
          <div class="btn-group mr-4">
            <router-link
              :class="{disabled: !evaData.previous_id}"
              class="btn btn-outline-primary"
              :to="`/machines/${id}/eva/${evaData.previous_id}`"
            >&laquo;</router-link>
            <router-link
              :class="{disabled: !evaData.next_id}"
              class="btn btn-outline-primary"
              :to="`/machines/${id}/eva/${evaData.next_id}`"
            >&raquo;</router-link>
          </div>
          <h2 class="page-heading">Отчет от {{evaData.date}}</h2>
        </div>
        <btn-action
          class="btn btn-outline-danger ml-auto"
          @click="resetEva"
          v-if="$root.user.role.name !== 'lessor_pro'"
        >После сброса</btn-action>
        <btn-action
          class="btn btn-outline-danger ml-2"
          @click="deleteEva"
          v-if="$root.user.role.name !== 'lessor_pro'"
        >Удалить отчет</btn-action>
      </div>
    </div>

    <div v-if="evaData.html">
      <div v-html="evaData.html"></div>
      <h2 class="page-heading container-fluid">Продажи из EVA</h2>
      <table class="table">
        <thead>
        <tr>
          <th>Количество продаж</th>
          <th>Сумма</th>
          <th>Тип продажи</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in evaData.eva_sales">
          <td>{{item.params.sales}}</td>
          <td>{{item.params.cost}}</td>
          <td>{{item.sale_type}}</td>
        </tr>
        </tbody>
      </table>
      <h2 class="page-heading container-fluid">Продукты из EVA</h2>
      <table class="table">
        <thead>
        <tr>
          <th>Продукт</th>
          <th>Количество продаж</th>
          <th>Сумма</th>
          <th>Тип продажи</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in evaData.eva_product">
          <td>{{productName(item.params.product_id)}}</td>
          <td>{{item.params.sales}}</td>
          <td>{{item.params.cost}}</td>
          <td>{{item.sale_type}}</td>
        </tr>
        </tbody>
      </table>
      <h2 class="page-heading container-fluid">Отмеченные события</h2>
      <table class="table">
        <thead>
        <tr>
          <th>id</th>
          <th>Продукт</th>
          <th>Сумма</th>
          <th>Тип продажи</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in evaData.sale">
          <td><router-link
            :to="`/reports/events/${item.id}`"
          >{{item.id}}</router-link></td>
          <td>{{item.params.product_name == '' ? item.params.product_id : item.params.product_name}}</td>
          <td>{{item.params.cost}}</td>
          <td>{{item.sale_type}}</td>
        </tr>
        </tbody>
      </table>
    </div>

    <h2 class="page-heading container-fluid">Исходный текст отчета</h2>
    <pre class="p-2 eva-raw bg-white">{{evaData.raw}}</pre>
  </div>
</template>

<script>
  import api from '@/api'
  import BtnAction from '../../../../components/btn-action'

  export default {
    components: {BtnAction},
    metaInfo: {title: 'Отчет EVA-DTS'},
    props: ['id', 'eva_id'],
    data () {
      return {}
    },
    asyncComputed: {
      evaData () {
        return api
          .get('eva/' + this.eva_id)
          .then(({data}) => data.data)
      },
    },
    computed: {
      keymap () {
        return {
          'alt+left': this.goPreviousUrl,
          'alt+right': this.goNextUrl,
        }
      },
      previousUrl () {
        return this.evaData.previous_id ? `/machines/${this.id}/eva/${this.evaData.previous_id}` : null
      },
      nextUrl () {
        return this.evaData.next_id ? `/machines/${this.id}/eva/${this.evaData.next_id}` : null
      },
      siblingUrl () {
        return this.previousUrl || this.nextUrl
      },
    },
    methods: {
      productName (productId) {
        return this.evaData.products[productId] || productId
      },
      deleteEva () {
        if (window.confirm('Удалить отчет?')) {
          return api
            .delete(`eva/${this.eva_id}`)
            .then(() => this.siblingUrl && this.$router.push(this.siblingUrl))
        }
      },
      resetEva () {
        if (window.confirm('Обработать как первый отчет после сброса?')) {
          return api.post(`eva/reset/${this.eva_id}`)
        }
      },
      goPreviousUrl () {
        if (this.previousUrl) {
          this.$router.push(this.previousUrl)
        }
      },
      goNextUrl () {
        if (this.nextUrl) {
          this.$router.push(this.nextUrl)
        }
      },
    },
  }
</script>

<style lang="scss">
  @import "boot";
  .eva-header {
    position: sticky;
    z-index: 100;
    top: 0;
    background: rgba($body-bg, .8);
    backdrop-filter: saturate(180%) blur(2px);
    box-shadow: 0 1px 3px rgba($gray-500, 0.2);
  }
  .table-eva-parsed-info {
    td {
      text-align: right;
    }
  }
  .eva-raw {
    width: 100%;
    white-space: pre-wrap;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/machines/_id/eva/_eva_id.vue